import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';

// slice
const headerSlice = createSlice({
  name: 'header',
  initialState: {
    title: null,
    breadcrumbs: []
  },
  reducers: {
    setHeaderTitle: (state, action) => {
      state.title = action.payload.titleText;
    },
    setBreadcrumbs: (state, action) => {
      state.breadcrumbs = action.payload.breadcrumbs;
    }
  }
});

export default headerSlice.reducer;
export const {setHeaderTitle, setBreadcrumbs} = headerSlice.actions;

